import React from 'react';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="w-full py-4 px-4 border-t border-slate-800 bg-slate-950/80 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-500">
        <p>© {currentYear} Socyy. All rights reserved.</p>
        <div className="flex items-center gap-4">
          <a href="/legal/privacy" className="hover:text-slate-300 transition-colors">Privacy Policy</a>
          <a href="/legal/terms" className="hover:text-slate-300 transition-colors">Terms of Service</a>
        </div>
      </div>
    </footer>
  );
}
